import * as React from "react";

function SvgDripIcon(props, ref) {
  return (
    <svg
      fillRule="evenodd"
      height="1em"
      width="1em"
      viewBox="0 0 70 70"
      {...{ ...props, ref }}
    >
      <path d="M11.635 38.7l2.525-.017c.868-.08 1.042.25 1.048 1.07.054 7.828 5.278 14.522 12.805 16.473 9.36 2.427 19.355-4.34 20.585-13.95.117-.912.225-1.837.196-2.752-.024-.746.274-.85.908-.838 1.804.034 3.6.06 5.413-.01.83-.032 1 .266.98 1.016-.246 9.424-4.376 16.646-12.57 21.262-14.756 8.313-33.347-1.283-35.4-18.133-.132-1.08-.144-2.156-.208-3.234-.047-.8.255-.948.96-.904.92.058 1.844.014 2.766.014zm6.062-22.667c3.218-4.426 6.63-8.392 10.26-12.174 1.137-1.185 2.327-2.32 3.476-3.493.343-.35.565-.565 1.046-.098 4.976 4.83 9.58 9.984 13.83 15.764-3.08 0-5.977-.004-8.875.003-.5.001-.635-.432-.86-.732l-4.075-5.5c-.398-.556-.6-.583-1-.008l-4.13 5.6c-.3.4-.593.653-1.163.645l-8.512-.017zm-.097 6.7c2.712.008 4.8 2.086 4.8 4.777 0 2.737-2.163 4.9-4.867 4.9-2.726-.02-4.803-2.174-4.78-4.956.02-2.698 2.1-4.72 4.848-4.7zm14.367 0c2.73-.01 4.848 2.034 4.874 4.703.027 2.755-2.08 4.938-4.8 4.964s-4.86-2.126-4.856-4.88c.004-2.728 2.046-4.775 4.773-4.785zm14.48-.001c2.717.001 4.82 2.07 4.83 4.75.01 2.74-2.137 4.92-4.84 4.917-2.722-.003-4.824-2.157-4.8-4.928.014-2.712 2.077-4.74 4.82-4.74z" />
    </svg>
  );
}

export default React.forwardRef(SvgDripIcon);
